<template>
<div class="chapter">
<div class="inner_page">
<p class="h2">CONTENTS</p>
<p class="toc"><a href="#/html/9780226431765_07_for">Foreword</a></p>
<p class="toc"><a href="#/html/9780226431765_08_pref">Preface</a></p>
<p class="toc"><a href="#/html/9780226431765_09_ch1">1. Botticelli Recovered</a></p>
<p class="toc"><span href="#/html/9780226431765_10_ch2" title="Link target outside of Sample">2. Cornelius and Voltemand: Doubles in <i>Hamlet</i></span></p>
<p class="toc"><span href="#/html/9780226431765_11_ch3" title="Link target outside of Sample">3. Disentangling Knowledge from Opinion</span></p>
<p class="toc"><span href="#/html/9780226431765_12_note" title="Link target outside of Sample">Notes</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226431765_06_toc.vue?2862a36e